export const rightFaqConfig = {
  selectCountry: [
    {
      title: 'Why incorporation status is required',
      description:
        ' Company Incorporation Status refers to the categorization of the company based on its age or duration since its inception. The options available are :- New (Less than 1 year old) Existing (1 year old or more)',
    },
  ],
};
